<div style="height: 100%; width: 100%;">
<optima-explorer
#strategyExplorer
[isLoading]="isLoading()"
[loadingItemId]="loadingNavigationItemId()"
[loadingItemIds]="loadingNavigationItemIds()"
[explorerAttributes]="explorerAttributes"
[contentTotalCount]="getPaginationTotalCount(explorerContentAttributes.currentSelectedItem || '', explorerContentAttributes.data.length)"
[contentItemCountPerPage]="contentItemCountPerPage"
[dataRefreshedToken]="dataRefreshedToken"
[useEntityHost]="true"
(paginationRequest)="onPaginationRequest($event)"
(subHeaderOnClickAddButtonOptionEmitter)="onAddButtonOptionClick($event)"
(subHeaderOnForwardButtonClickedEmitter)="itemClicked($event,false)"
(explorerNavonExplorerNavOnItemRightClickEmitter)="processContentContextMenuClicked($event)"
(explorerNavOnNavItemClickedEmitter)="navItemClicked($event)"
(explorerContentOncontextMenuClickEmitter)="processContentContextMenuClicked($event)"
(explorerContentOnEntityHostItemClickedEmitter)="selectClickedItem($event)"
(explorerContentOnEntityHostItemDoubleClickedEmitter)="onEntityHostItemDoubleClicked($event)"
(explorerContentOnEntityHostItemEventEmitter)="onEntityHostCardEvent($event)"
(explorerNavOnHierarchyChangeEmitter)="onHierarchyChange($event)"></optima-explorer>
</div>
<!-- <app-off-canvas-collective></app-off-canvas-collective> -->